import React, { useState } from 'react'
import Dropzone from 'react-dropzone'
import { Box, Grid, Typography } from '@mui/material'
import imageService from '../../../../services/imageService'
import { useSnackbar } from 'notistack'
import axios from 'axios'
import { useFormContext } from 'react-hook-form'

const FileUploadDropZone = ({ methodName }) => {
  const methods = useFormContext()
  const images = methods.watch(methodName)
  const [uploadProgress, setUploadProgress] = useState(0)
  const { enqueueSnackbar } = useSnackbar()
  const acceptedFileTypes = ['image/png', 'image/jpeg', 'image/jpg']

  const onDropHandler = acceptedFiles => {
    acceptedFiles.forEach(acceptedFile => {
      if (acceptedFileTypes.includes(acceptedFile.type)) {
        const data = { imageKey: acceptedFile.name }
        imageService.getPresignedUrl(data)
          .then(res => {
            uploadToPresignedUrl(acceptedFile, res.presignedUrl)
              .then(() => {
                enqueueSnackbar('Successfully uploaded your image!', { variant: 'success' })
              })
              .catch((err) => {
                console.log(err)
                enqueueSnackbar('Something went wrong', { variant: 'warning' })
              })
          })
          .catch(err => enqueueSnackbar(err, { variant: 'warning' }))
      } else {
        onDropRejected()
      }
    })
  }

  const onDragOverHandler = () => {
  }

  const onDropRejected = () => {
    enqueueSnackbar('This file type is not allowed', { variant: 'warning' })
  }

  const uploadToPresignedUrl = async (fileToUpload, presignedUrl) => {
    if (!isFileDuplicate(fileToUpload)) {
      const uploadResponse = await axios.put(presignedUrl, fileToUpload, {
        headers: {
          'Content-Type': fileToUpload.type
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          setUploadProgress(percentCompleted)
          console.log(`Upload Progress: ${percentCompleted}%`)
        }
      })
      images
        ? (
            methods.setValue(methodName, [
              ...images,
              process.env.REACT_APP_REDDITLIKE_IMAGE_BASE_URL + '/' + uploadResponse.config.data.path
            ])
          )
        : (
            methods.setValue(methodName, [
              process.env.REACT_APP_REDDITLIKE_IMAGE_BASE_URL + '/' + uploadResponse.config.data.path
            ])
          )
    }
  }

  const isFileDuplicate = fileToUpload => {
    let result = false
    images?.forEach(url => {
      if (url.split('/').splice(-1)[0] === fileToUpload.path) {
        result = true
      }
    })
    return result
  }

  return (
    <Dropzone onDrop={onDropHandler} onDragOver={onDragOverHandler} onDropRejected={onDropRejected}>
      {({ getRootProps, getInputProps }) => (
      <Grid>
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <Box height={200}
                 my={4}
                 display="flex"
                 alignItems="center"
                 justifyContent="center"
                 gap={4}
                 p={2}
                 sx={{ border: '2px solid grey' }}>
              <Typography>Drag &#39;n&#39; drop some files here, or click to select files</Typography>
            </Box>
            {images
              ? <Box>
                <Typography>Uploaded Files</Typography>
                {images.map(
                  (url) =>
                    (
                      <Typography key={url.split('/').slice(-1)[0]} component="p" sx={{ paddingLeft: '1.5rem' }}>
                        {url.split('/').slice(-1)[0]}
                      </Typography>
                    )
                )}
              </Box>
              : <></>
            }
          </div>
      </Grid>
      )}
    </Dropzone>
  )
}

export default FileUploadDropZone
